import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { SharedService } from '../shared.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { FirstLetterUpperCase } from '../pipe/firstletteruppercase.pipe';
import { LowerCasePipe } from '@angular/common';
import { TDUModel } from '../models/shared-models';

declare var google; // global variable declare

@Component({
	selector: 'app-enroll',
	templateUrl: './enroll.component.html',
	styleUrls: ['./enroll.component.css'],
	providers: [LowerCasePipe]
})
export class EnrollComponent implements OnInit {

	// validation field required
	serviceAddressFormControl = new FormControl('', [Validators.required]);
	apartmentFormControl = new FormControl('', [Validators.required]);

	// public variable define
	public zipcode: string;
	public service_address_search: string;
	public tdus: Array<TDUModel>;
	public duns: string;
	public is_component_load: boolean;
	public is_apt_exist: boolean;
	public error_message: string;
	public apt_units: any = [];
	public apt_unit: string;
	public apartment_list: any = [];
	public apartment_obs: Observable<string[]>;
	public is_loader: boolean;
	public esiid: string;
	public tdu: string;
	public multiple: boolean;
	public old_key: number;
	public which_event: string;
	public places: any;
	public is_address_addlis: boolean;
	public search_val: any;
	options = [];
	public request: any;

	// define constructor
	constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
		private router: Router, private localStorageService: LocalStorageService,
		private firstLetterPipe: FirstLetterUpperCase, private lowerCasePipe: LowerCasePipe) {
		this.service_address_search = '';
		this.which_event = '';
		this.sharedService.setHeaderTitle('default_page');
		// verify token
		if (this.localStorageService.get('token') != null) {
			this.sharedService.verifyToken({ 'token': this.localStorageService.get('token') })
				.then(res => {
					if (res.status === 'success' && res.isTerminated === false) {
						this.router.navigate(['./dashboard']);
					} else {
						this.localStorageService.remove('token');
						this.localStorageService.remove('tempToken');
						this.router.navigate(['./sign-in']);
					}
				});
		} else {
			this.is_component_load = true;
			this.zipcode = '';
			this.duns = '';
			this.apt_unit = '';
			this.is_apt_exist = false;
			this.is_loader = false;
			this.esiid = '';
			this.tdu = '';
			this.multiple = false;
			this.zipcode = '';
			this.is_address_addlis = false;

			this.sharedService.getElectricUtilityProviders().then(activeTdus => {
				this.tdus = activeTdus;
			});

			// set page header title
			const that = this.sharedService;
			setTimeout(function () {
				that.setHeaderTitle('home');
				// if (document.getElementById('service_address_id') !== undefined) {
				//   document.getElementById('service_address_id').focus();
				// }
			}, 50);
			if (this.localStorageService.get('validate_address') !== undefined &&
				this.localStorageService.get('validate_message') !== undefined) {
				this.service_address_search = <string>this.localStorageService.get('validate_address');
				this.error_message = <string>this.localStorageService.get('validate_message');
				setTimeout(function () {
					document.getElementById('is_error_address').removeAttribute('style');
					document.getElementById('is_error_address_yellow').removeAttribute('style');
				}, 100);
				this.localStorageService.remove('validate_address');
				this.localStorageService.remove('validate_message');
			}
		}
	}

	// validate apt or unit
	addClass() {
		setTimeout(function () {
			// tslint:disable-next-line:max-line-length
			const setPos = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-pane')[document.getElementsByClassName('cdk-overlay-pane').length - 1];
			if (!setPos.classList.contains('home1-auto-cls')) {
				setPos.classList.add('home1-auto-cls');
			}
			setPos.parentElement.classList.add('cdk-overlay-container-static');
		}, 10);

		setTimeout(function () {
			const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
			setcls.classList.add('nav-cls');
		}, 10);
	}

	removeClass() {
		const setcls = <HTMLScriptElement>document.getElementsByClassName('sidenav-container')[0];
		setcls.classList.remove('nav-cls');
		const removeCls = <HTMLScriptElement>document.getElementsByClassName('cdk-overlay-container')[0];
		if (removeCls.classList.contains('cdk-overlay-container-static')) {
			removeCls.classList.remove('cdk-overlay-container-static');
		}

	}


	// find tdus using address or zipcode
	getTDUs() {
		if (this.duns !== '' && this.esiid !== '') {
			let selectedTdu = this.tdus.find((x) => x.duns == this.duns);
			this.router.navigate(['./enroll/esiid/' + this.esiid + '/tdu/' + selectedTdu.tduCode]);
		}
		else if (this.multiple) {
			this.router.navigate(['./enroll/zipcode/' + this.zipcode]);
		}
		else if (!this.multiple && this.tdu !== '') {
			this.router.navigate(['./enroll/zipcode/' + this.zipcode + '/tdu/' + this.tdu]);
		}
		else {
			document.getElementById('is_error_address').setAttribute('style', 'display:none');
			document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
			document.getElementById('home_next').setAttribute('disabled', '');
			document.getElementById('is_apt_exist').setAttribute('style', 'display:none');
		}
	}

	showRequire() {
		const len = document.getElementsByTagName('body')[0];
		len.click();
	}

	addressMatch() {
		document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
		document.getElementById('is_error_address').setAttribute('style', 'display:none');
		document.getElementById('home_next').setAttribute('disabled', '');
		document.getElementById('is_loader').setAttribute('style', '');
		if (this.request) {
			this.request.unsubscribe();
		}
		this.request = this.sharedService.getServiceAddresses(this.service_address_search)
			.subscribe(response => {
				document.getElementById('is_loader').setAttribute('style', 'display:none');
				this.options = [];
				for (let i = 0; i < response.result.length; i++) {
					this.options.push(response.result[i]);
				}
			});
	}

	validateAddress(address_obj: any) {
		document.getElementById('is_loader').setAttribute('style', 'display:none');
		this.service_address_search = address_obj.address_full;
		this.duns = address_obj.duns;
		this.esiid = address_obj.esi_id;
		this.localStorageService.set('address_for_billing', address_obj);
		this.sharedService.validateAddress({ 'ercotId': address_obj.id })
			.then(res => {
				if (res.status === 'success') {
					document.getElementById('is_error_address').setAttribute('style', 'display:none');
					document.getElementById('is_error_address_yellow').setAttribute('style', 'display:none');
					const len = document.getElementsByTagName('body')[0];
					len.click();
					const dis = document.getElementById('home_next');
					dis.removeAttribute('disabled');
					dis.focus();
					if (address_obj.apt_unit != null && address_obj.apt_unit !== '') {
						document.getElementById('is_apt_exist').removeAttribute('style');
					}
				} else {
					if (res.color === 'yellow') {
						document.getElementById('is_error_address_yellow').removeAttribute('style');
						document.getElementById('is_error_address_yellow').innerHTML = '<p>' + res.message + '</p>';
					} else {
						document.getElementById('is_error_address').removeAttribute('style');
						document.getElementById('is_error_address').innerHTML = '<p>' + res.message + '</p>';
					}
					document.getElementById('home_next').setAttribute('disabled', '');
				}
			});
	}
	// onload method bound google api with texas
	ngOnInit() {
		const len = document.getElementsByTagName('body')[0];
		len.classList.add('body_autocomplete');
		if (len.classList.contains('fix-overlay-div')) {
			len.classList.remove('fix-overlay-div');
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/enroll/enroll.component.ts